module.exports = __webpack_public_path__ + "static/media/cooper-surgical-r-md-logo-ko@2x.6cd830d6.png";